import React from "react";
import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import Cache from "i18next-localstorage-cache";
import sprintf from "i18next-sprintf-postprocessor";
import { initReactI18next } from "react-i18next";

/*
import locizeEditor from 'locize-editor';
import i18next from 'locize';
import Backend from 'i18next-locize-backend';
 */

let default_language = "en_GB";
let languages = ["en_GB"];
if (window.NTLF_CONFIG?.portal.locale) {
  ({ default_language, languages } = window.NTLF_CONFIG.portal.locale);
}

default_language = default_language.replace("_", "-");

const lang = (window.NTLF_CONFIG?.user?.lang || default_language).replace(
  "_",
  "-",
);

// Support for ntlf {{description}} context for translations. Requires skipInterpolation to be set:
const ntlfContext = {
  type: "postProcessor",
  name: "ntlf-context",
  process: function (value, key, options, translator) {
    // Only used if skipInterpolation:
    if (options.skipInterpolation) {
      return value.replace(/\s*\{\{.+\}\}/, "");
    } else {
      return value;
    }
  },
};

function getLocaleBasePath() {
  if (window.NTLF_CONFIG?.portal.i18n_base_path) {
    return window.NTLF_CONFIG.portal.i18n_base_path;
  }
  return "";
}

i18n
  .use(HttpBackend)
  .use(Cache)
  .use(sprintf)
  .use(initReactI18next)
  .use(ntlfContext)
  .init({
    debug: true,
    ns: ["epmsweb", "phplibepms"],
    defaultNS: "epmsweb",
    fallbackNS: "phplibepms",
    lngWhiteList: languages,
    lng: lang,
    load: "currentOnly",
    // Use key as fallback
    fallbackLng: default_language,
    backend: {
      loadPath: getLocaleBasePath() + "/locale/{{lng}}/{{ns}}.json",
      resGetPath: "/locale/{{lng}}/{{ns}}.json",
      addPath: "/locale/add_translation.php?lng={{lng}}&&ns={{ns}}",
      allowMultiLoading: false,
    },
    saveMissing: false,
    nsSeparator: false,
    keySeparator: false,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      //defaultTransParent: Wrapper,
    },
  });

export default i18n;
